export default __webpack_public_path__ + "static/media/raphael.6da96492.jpeg";